import { IDoctorListItem, IRequestDoctorInfo } from './doctor';
import { IRequest } from './request';

export enum PaymentMethods {
  CARD = 1,
  ACCOUNT = 2,
}
export enum RegisteredTypes {
  PHONE = 1,
  CARD = 2,
}
export enum ReceiptsTypes {
  INCOME = 1,
  EXPENSE = 2,
}

export interface IRequestPay {
  clientId: String;
  method: String;
  vbankHolder: String;
  orderId: String;
  amount: Number;
  goodsName: String;
  returnUrl: String;
  mailReserved: String;
  fnError: (result: any) => void;
  requestKey?: String;
  requestKind?: String;
}

export interface IResultPayment {
  ResultCode: Number;
  Exception: any;
  Amount: Number;
  AmountText: String;
  ProductName: String;
  OrderId: any;
  RequestKey: String;
  RequestKind: String;
}

export interface IPaymentInfo {
  PaymentKey: Number;
  RefKey: Number;
  ProductName: String;
  PaymentAmount: Number;
  OrderNumber: String;
  InsertDateTime: String;
  PaidDateTime: String;
  PaymentStatus?: Number;
  PaymentStatDesc: String;
  ExpireDateTime: String;
  Exception: String;
  HospitalPID: String;
  UserName: String;
  DoctorID: String;
  DoctorName: String;
  ScheduledDateTime: String;
}

export interface IPayInfo {
  PaymentInfo: IPaymentInfo;
  DoctorInfo: IDoctorListItem;
  RequestInfo: IRequest;
}

/**
 * @see {@link IRequestDoctorInfo}
 */
export interface IPaymentItem extends IRequestDoctorInfo {
  PaymentAmount: String;
  PaymentKey: Number;
  PaidMonth: String;
  PaidDateTime: String;
}

export interface IPaidItem {
  PaidDateTime: String;
  PaidAmmount: String;
  PayMethod: String;
  OrderNumbwer: String;
  PayStatus: Number;
}

export enum PayStatuses {
  READY = 10,
  PAID = 100,
  REFUND_REQUEST = 301,
  REFUND = 302,
}
